import { NavLink } from "react-router-dom";

const BottomNav = () => {
    return (
        <ul className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 md:gap-8 xl:gap-10">
            <NavItem text={"Financial Health Checkup"} to={"/fhc"} />
            <NavItem text={"Buying Home"} to={"/bh"} />
            <NavItem text={"Allocate Savings"} to={"/as"} />
            <NavItem text={"Debt Management"} to={"/dm"} />
            <NavItem text={"Value Spending"} to={"/vp"} />
            <NavItem text={"Saving for a Goal"} to={"/sfg"} />
        </ul>
    );
};

export default BottomNav;

const NavItem = ({ text, to }) => {

    return <NavLink
        to={to}
        className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ?
                "bg-gradient-to-r from-primary to-patric-blue rounded-xl py-2 px-2 text-white text-center flex items-center justify-center hover:from-primary/10 hover:to-primary/10 hover:text-primary duration-300" :
                "bg-primary/10 text-primary rounded-xl py-2 px-2 text-center flex items-center justify-center hover:bg-gradient-to-r hover:from-primary hover:to-patric-blue hover:text-white duration-300"}
    >
        {text}
    </NavLink>;
};